import request from '../utils/request';
//公告列表
export function toListMessage(data) {
  return request({
    url: 'webIndex/getNewsList.html',
    method: 'get',
    params:data
  });
}

//资讯详情
export function getInfoDetail(data) {
  return request({
    url: 'webIndex/getNewsDetail.html',
    method: 'get',
    params:data
  });
}

//学时证明
export function toCreditZM(data) {
  return request({
    url: '/web/toCreditZM.html',
    method: 'post',
    data
  });
}

//提交商务合作
export function toBusinessCooperation(data) {
  return request({
    url: 'webIndex/toBusinessCooperation.html',
    method: 'post',
    data
  });
}
